<atlas-modal #modal titleText="{{ headerText$ | async }}">
    <atlas-modal-header>{{ headerText$ | async }}</atlas-modal-header>
    <atlas-modal-content width="550px" maxHeight="400px">
        <div class="business-navbar__sales-info__sales-card" *ngIf="(salespersonContact$ | async) as contact">
            <div class="business-navbar__sales-info__sales-card__picture">
                <img [src]="contact.photoUrlSecure">
            </div>
            <div class="business-navbar__sales-info__sales-card__contact-details">
                <div class="business-navbar__sales-info__sales-card__contact-details__name">{{ contact.firstName }} {{ contact.lastName }}</div>
                <div class="business-navbar__sales-info__sales-card__contact-details__title">{{ contact.jobTitle }}</div>
                <div class="business-navbar__sales-info__sales-card__contact-details__phone-number"><a
                        [href]="'tel:' + contact?.phoneNumber">{{ formatPhoneNumber(contact?.phoneNumber, contact.country) }}</a></div>
                <div class="business-navbar__sales-info__sales-card__contact-details__email"><a
                        [href]="'mailto:' + contact.email">{{ contact.email }}</a></div>
            </div>
        </div>
        <div class="business-navbar__sales-info__message-composer">
            <atlas-textarea [(text)]="messageTxt" maxHeight="280px" limit="500"
                            [prescriptionText]="prescriptionText$ | async"></atlas-textarea>
        </div>
    </atlas-modal-content>
    <atlas-modal-footer>
        <atlas-button [text]="cancelText$ | async" (onClick)="closeModal()"></atlas-button>
        <atlas-button
            [text]="submitText$ | async"
            [raised]="true"
            [loading]="sendingMessage"
            [disabled]="messageTxt?.length > 500 || (isAdminView$ | async)"
            [atlasTooltip]="tooltipText$ | async"
            [atlasTooltipDisabled]="!(isAdminView$ | async)"
            (onClick)="sendMessage()"
        ></atlas-button>
    </atlas-modal-footer>
</atlas-modal>
